import type { RouteRecord } from 'vite-react-ssg'
import App from './App'
import Home from './pages/Home'
import Services from './pages/Services'
import ManagedIT from './pages/ManagedIT'
import AIAutomation from './pages/AIAutomation'
import Contact from './pages/Contact'
import HubSupport from './pages/HubSupport'
import Privacy from './pages/Privacy'
import SmsTerms from './pages/SmsTerms'
import SmsMarketingTerms from './pages/SmsMarketingTerms'
import NextTechConsultantsMasterServiceAgreement from './pages/NextTechConsultantsMasterServiceAgreement'
import NotFound from './pages/NotFound'

async function getBlogSlugs(): Promise<string[]> {
  // This is for SSG build-time only. In-browser execution can hit non-JSON
  // responses during edge deploy transitions and cause route crashes.
  if (!import.meta.env.SSR) return []
  try {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'
    const response = await fetch(`${baseUrl}/api/blog/posts?limit=100`)
    if (!response.ok) return []
    const contentType = response.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) return []
    const data = await response.json()
    const posts = Array.isArray(data) ? data : (data.posts || [])
    return posts.map((p: { slug: string }) => `blog/${p.slug}`)
  } catch {
    return []
  }
}

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, Component: Home },
      { path: 'services', Component: Services },
      { path: 'services/managed-it', Component: ManagedIT },
      { path: 'services/ai-automation', Component: AIAutomation },
      {
        path: 'services/ai-automation/compare',
        lazy: () => import('./pages/AIComparisonMatrix'),
        entry: 'src/pages/AIComparisonMatrix.tsx',
      },
      { path: 'security', lazy: () => import('./pages/Security'), entry: 'src/pages/Security.tsx' },
      { path: 'about', lazy: () => import('./pages/About'), entry: 'src/pages/About.tsx' },
      { path: 'pricing', lazy: () => import('./pages/Pricing'), entry: 'src/pages/Pricing.tsx' },
      { path: 'contact', Component: Contact },
      { path: 'hub-support', Component: HubSupport },
      { path: 'privacy', Component: Privacy },
      { path: 'sms-terms', Component: SmsTerms },
      { path: 'sms-marketing-terms', Component: SmsMarketingTerms },
      { path: 'nexttech-consultants-master-service-agreement', Component: NextTechConsultantsMasterServiceAgreement },
      {
        path: 'chiropractic',
        lazy: () => import('./pages/Chiropractic'),
        entry: 'src/pages/Chiropractic.tsx',
      },
      {
        path: 'chiropractic/thank-you',
        lazy: () => import('./pages/ChiropracticThankYou'),
        entry: 'src/pages/ChiropracticThankYou.tsx',
      },
      {
        path: 'build-your-first-agent',
        lazy: () => import('./pages/BuildYourFirstAgent'),
        entry: 'src/pages/BuildYourFirstAgent.tsx',
      },
      { path: 'blog', lazy: () => import('./pages/Blog'), entry: 'src/pages/Blog.tsx' },
      {
        path: 'blog/:slug',
        lazy: () => import('./pages/BlogPost'),
        entry: 'src/pages/BlogPost.tsx',
        getStaticPaths: getBlogSlugs,
      },
    ],
  },
  { path: '*', element: <NotFound /> },
]
